export default "__VITE_ASSET__27b91399__"